<template>
    <v-container>
        <v-row>
            <v-col>
                <terminuebersicht></terminuebersicht>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import terminuebersicht from '@/components/terminuebersicht.vue';

export default {
    components: {
        terminuebersicht
    },
    data : () => ({ }),
    mounted () {}
}
</script>
